import React from 'react';
import MenuPackingLists from './MenuPackingLists';
import MenuMaintenanceTracker from './MenuMaintenanceTrackers';
import ThemeDemo from '../ThemeDemo';
import { useTheme } from '../../utils/ThemeContext';
import { Container, Row, Col } from 'react-bootstrap';
import './HomeNav.css';

/**
 * Home component that serves as a parent container for different sections
 * 
 * @param {Object} props - Component props
 * @param {Object} props.user - Current authenticated user object
 * @returns {JSX.Element} Rendered component
 */
const Home = ({ user }) => {
  const { theme } = useTheme();
  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
    <div className="home-container" data-bs-theme={theme}>
      <Container fluid className="px-0">
        {isDevelopment && <ThemeDemo />}
        
        <Row className="mx-0">
          <Col className="px-md-0 px-0">
            <div className="home-content">
              <div className="home-section">
                <h2 className="heading-medium-centered">Packing Lists</h2>
                <MenuPackingLists user={user} />
              </div>
              <div className="home-section">
                <h2 className="heading-medium-centered">Maintenance Trackers</h2>
                <MenuMaintenanceTracker user={user} />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Home;
